import * as _ from "lodash";
import {IComponentOptions, ILogService} from "angular";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {Application} from "../../model/Application";
import {Credit} from "../../model/Credit";
import {Assessment} from "../../model/Assessment";
import {CPARSearchRequest} from "../../model/CPARSearchRequest";
import {CPARSearchResponse, Precedent} from "../../model/CPARSearchResponse";
import {LoadingService} from "../../loading/loading.service";
import {PriorCourse} from "../../model/PriorCourse";
import {PriorCourseUnit} from "../../model/PriorCourseUnit";
import {StudyUnitService} from "../../study-unit/study-unit.service";
import {CparService} from "../../cpar/cpar.service";
import {Discipline} from "../../model/Discipline";

class SearchPrecedentModalController {

    public modalInstance: IModalInstanceService;
    public resolve: any;
    public close: any;
    public dismiss: any;
    public form: any;
    public showErrors: boolean;
    public institution: any;
    public yearCompleted: string;
    public application: Application;
    public assessment: Assessment;
    public cparSearchRequest: CPARSearchRequest = new CPARSearchRequest();
    public cparSearchResponse: CPARSearchResponse;

    private processing: boolean;

    /* @ngInject */
    constructor(private $log: ILogService,
                private toaster: any,
                private loadingService: LoadingService,
                private studyUnitService: StudyUnitService,
                private cparService: CparService) {
    }

    public $onInit() {
        this.application = this.resolve.application;
        this.assessment = this.resolve.assessment;
        const priorInstitutions = _.filter(this.application.priorStudies, (priorStudy: PriorCourse) => {
            return _.some(priorStudy.units, (unit: PriorCourseUnit) => {
                if (unit.unitCode === this.assessment.priorCourseUnits[0].unitCode &&
                    unit.unitTitle === this.assessment.priorCourseUnits[0].unitTitle) {
                    this.yearCompleted = "" + unit.yearCompleted;
                    return true;
                } else {
                    return false;
                }
            });
        });
        if (priorInstitutions.length) {
            this.institution = priorInstitutions[0].institution;
        }
        this.cparSearchRequest.externalUnitCode = this.assessment.priorCourseUnits[0].unitCode;
        this.cparSearchRequest.externalUnitTitle = this.assessment.priorCourseUnits[0].unitTitle;
        this.$log.debug("Matching institution: %o", this.institution);
    }

    public searchByPrecedent() {
        this.showErrors = false;
        this.cparSearchResponse = null;
        if (!this.cparSearchRequest.precedentId) {
            this.toaster.pop({type: "error", title: "Precedent ID must be populated"});
            return;
        }

        this.cparSearchRequest.externalInstId = null;
        this.cparSearchRequest.externalUnitCode = null;
        this.cparSearchRequest.externalUnitTitle = null;
        this.cparSearchRequest.externalYearCompleted = null;
        this.search();
    }

    public searchByInst() {
        this.showErrors = false;
        this.cparSearchResponse = null;
        if (this.form.$invalid) {
            this.showErrors = true;
            this.toaster.pop({type: "error", title: "Institution must be populated"});
            return;
        }

        if (this.institution.code) {
            this.cparSearchRequest.externalInstId = this.institution.code;
        }

        this.cparSearchRequest.externalYearCompleted = this.yearCompleted;
        this.cparSearchRequest.precedentId = null;
        this.search();
    }

    public applyPrecedent(precedent: Precedent) {
        this.$log.debug("Applying precedent %o", precedent);
        this.assessment.precedentId = precedent.precedentId;
        this.assessment.precedentStatus = precedent.status;

        precedent.credits.forEach((precedentCredit) => {
            const credit = new Credit();
            if (precedentCredit.creditType === "unspecifiedCredit") {
                credit.type = "UNSPECIFIED_CREDIT";
                credit.discipline = new Discipline(precedentCredit.disciplineGroupCode, precedentCredit.discipline);
                credit.unitLevel = `UNIT_LEVEL_${precedentCredit.unitLevel}`;
                credit.creditPoints = precedentCredit.creditPoints;
            } else {
                credit.type = "SPECIFIED_CREDIT";
                credit.monashUnitCode = precedentCredit.unitCode ? precedentCredit.unitCode : precedent.unitVersion.unitCode;
                credit.monashUnitVersion = precedentCredit.versionNumber;
                credit.specifiedCreditType = precedentCredit.category;
                this.studyUnitService.search(precedentCredit.unitCode).then((response: any) => {
                    this.$log.debug("Found unit: %o", response);
                    credit.creditPoints = response && response[0] ? response[0].achievableCreditPoints : 0;
                });
            }
            this.assessment.credits.push(credit);
        });


        this.toaster.pop({type: "success", title: "Precedent has been applied to the assessment"});
        this.close({$value: this.assessment});
    }

    public cancel() {
        this.dismiss({$value: "cancel"});
    }

    private search() {
        this.processing = true;
        this.loadingService.show();
        this.$log.info("search() %o", this.cparSearchRequest);
        this.cparService.searchCPARPrecedents(this.cparSearchRequest).then((results: any) => {
            this.cparSearchResponse = results;
        }).finally(() => {
            this.processing = false;
            this.loadingService.hide();
        });
    }
}

export const SearchPrecedentModalComponent: IComponentOptions = {
    bindings: {
        modalInstance: "<",
        resolve: "=",
        close: "&",
        dismiss: "&"
    },
    controller: SearchPrecedentModalController,
    template: require("./search-precedent-modal.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/assessment/search-precedent/search-precedent-modal.component.ts